import * as React from 'react'

import styled from '@emotion/styled'

import { getArcadeLinkStyles } from '../../styles'
import { typography } from '../../theme'
import Text from '../Text/Text'

export type ArcadeLinkProps = {
  href: string
  ariaLabel?: string
  typography?: keyof Pick<typeof typography, 'linkMedium' | 'linkSmall'>
  target?: string
  rel?: string
  onClick?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void
}

const LinkContainer = styled.a`
  ${props => getArcadeLinkStyles(props.theme)}
`

const ArcadeLink: React.FC<React.PropsWithChildren<ArcadeLinkProps>> = ({
  href,
  ariaLabel,
  typography = 'linkMedium',
  children,
  target,
  rel,
  onClick,
}) => (
  <LinkContainer
    href={href}
    {...(ariaLabel ? { 'aria-label': ariaLabel } : {})}
    target={target}
    rel={rel}
    onClick={onClick}
  >
    <Text as="span" typography={typography}>
      {children}
    </Text>
  </LinkContainer>
)

export default ArcadeLink
